import { isMac } from "helpers/isMac";
import { isMobile } from "helpers/isMobile";

export enum RichTextVariables {
  Message = "message",
  RequesterName = "requesterName",
  RequesterEmail = "requesterEmail",
  ShortID = "shortID",
  AgentName = "agentName",
  AgentEmail = "agentEmail",
  Subject = "subject",
  TicketHistory = "ticketHistory",
  PeopleInTheLoop = "peopleInTheLoop",
}

export enum RichTextPluginTypes {
  WithBold = "withBold",
  WithCode = "withCode",
  WithItalic = "withItalic",
  WithUnderline = "withUnderline",
  WithStrikethrough = "withStrikethrough",
  WithBulletedList = "withBulletedList",
  WithNumberedList = "withNumberedList",
}

export enum RichTextEditorPlugins {
  HistoryPlugin = "historyPlugin",
  LinksPlugin = "linksPlugin",
  HTMLCopyPastePlugin = "htmlCopyPastePlugin",
  RichTextPlugin = "richTextPlugin",
  ListBreaksPlugin = "listBreaksPlugin",
  OnelineHeadersPlugin = "onelineHeadersPlugin",
  BlockSoftBreaksPlugin = "blockSoftBreaksPlugin",
  VariablesPlugin = "variablesPlugin",
  ReactPlugin = "reactPlugin",
  ImagesPlugin = "imagesPlugin",
  SlateCopyPastePlugin = "slateCopyPastePlugin",
  BuildMentionsPlugin = "buildMentionsPlugin",
  CreateCannedResponsesPlugin = "createCannedResponsesPlugin",
  AttachmentsPlugin = "attachmentsPlugin",
}

export type RichTextPluginProps = {
  [key in RichTextPluginTypes]?: boolean;
};

export type RichTextEditorPluginProps = {
  [key in RichTextEditorPlugins]?: boolean;
};

export type RichTextVariablesPluginProps = {
  [key in RichTextVariables]?: boolean;
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const shortcutTooltip = (shortcut: string, label: string) => {
  if (isMobile(navigator.userAgent)) {
    return label;
  }

  let platformShortcut;
  if (isMac(navigator.userAgent)) {
    platformShortcut = shortcut.replace(/mod/, "⌘");
  } else {
    platformShortcut = shortcut.replace(/mod/, "Ctrl");
  }

  return `${label} (${platformShortcut})`;
};
